import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../services/auth.service';
import { FactLanguageService } from './../../services/fact-language.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-factoring-language',
  templateUrl: './factoring-language.component.html',
  styleUrls: ['./factoring-language.component.css']
})
export class FactoringLanguageComponent implements OnInit {
  user_id: any='';
  id:any =0;
  token:any='';
  APIKEY:any= 'SOAV2@123';
  factLangForm: FormGroup;
  buttonDisabled: boolean;
  model: any = {};
  public loading = false;

  constructor(
    private _factLang:FactLanguageService,
    private _router : Router,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
   
  ) 
  { }


  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.token =localStorage.getItem('token');
    this.getfactLang();
    this.model= { id:this.id,
        user_id:this.user_id,
        api_token :this.token,
        APIKEY : this.APIKEY
      };
    this.buttonDisabled = false;
   }
 

  onSubmit() {
   this.buttonDisabled = true; 
   this.loading = true;
   this._factLang.storefactLang(this.model)
    .subscribe(
      res => {  
          if(res.status==true){
            this.toastr.success(res.message, 'Success');
          }
          else{
            this.toastr.error(res.message, 'Error');
          }
          this.getfactLang();         
          this._router.navigateByUrl('super-admin/customer-list/all').then(() => {
            this._router.navigateByUrl('super-admin/factoring-language');
         });
     },
     
    ); 
    
  }



 

 
  



//
  getfactLang()
  {
    const getFactlang = {
       user_id:this.user_id,
       api_token :this.token,
       APIKEY : this.APIKEY
    }
    this._factLang.getFactactLang(getFactlang)
    .subscribe(
      res => { 
         this.model.id= res.id;
         this.model.assigneNotice= res.assigned_notice;
         this.model.instructions= res.instructions;
         this.model.financeCompany= res.finance_company;
         this.model.factAddress1= res.fact_address1;
         this.model.factCityState= res.fact_city_state;
         this.model.factEmail= res.fact_email;
         this.model.factPhone= res.fact_phone;
         this.model.soaAssignment= res.soa_assignment;
         this.model.factSoaEmail= res.fact_soa_email;
         this.model.factAuthPerson= res.fact_auth_person;
         this.model.email_per_invoice= res.email_per_invoice;
         this._router.navigate(['super-admin/factoring-language']);
     },
    ); 
  }


}
